import React from "react";
import { Alert, AlertProps, AlertTitle, Box } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";

export interface ErrorMessageProps extends Omit<AlertProps, "severity"> {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}

/**
 * Composant ErrorMessage pour afficher les erreurs
 *
 * @example
 * ```tsx
 * <ErrorMessage message="Une erreur s'est produite" />
 *
 * <ErrorMessage
 *   title="Erreur de chargement"
 *   message="Impossible de charger les données"
 *   onRetry={handleRetry}
 *   retryLabel="Réessayer"
 * />
 * ```
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title,
  message,
  onRetry,
  retryLabel = "Réessayer",
  sx,
  ...props
}) => {
  return (
    <Alert
      severity="error"
      icon={<ErrorOutline />}
      action={
        onRetry && (
          <Box sx={{ mt: 1 }}>
            <button
              onClick={onRetry}
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                textDecoration: "underline",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              {retryLabel}
            </button>
          </Box>
        )
      }
      sx={{
        borderRadius: 2,
        ...sx,
      }}
      {...props}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  );
};
